// extracted by mini-css-extract-plugin
export default {"dropzone":"dropzone_dropzone__ZaLak","dropzoneContent":"dropzone_dropzoneContent__q5Ru3","dropzoneContentNone":"dropzone_dropzoneContentNone__U0ky0"};